// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"Passionate_sectionContainer__QBz_8","containerCenter":"Passionate_containerCenter__rFGtm","textContainer":"Passionate_textContainer__yKAGU"};